!(function () {
  "use strict";
  class e {
    constructor(e, t) {
      ((this.configuration = {
        expires: null,
        path: "/",
        domain: window.location.hostname,
        sameSite: "none",
        secure: !0,
      }),
        (this.name = e),
        (this.value = t));
    }
    write() {
      ((-1 !== document.cookie.indexOf("; ") &&
        !document.cookie.split("; ").find((e) => e.startsWith(this.name))) ||
        -1 === document.cookie.indexOf("; ")) &&
        (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
    read() {
      if (
        -1 !== document.cookie.indexOf("; ") &&
        document.cookie.split("; ").find((e) => e.startsWith(this.name))
      ) {
        return document.cookie
          .split("; ")
          .find((e) => e.startsWith(this.name))
          .split("=")[1];
      }
      return !1;
    }
    destroy() {
      document.cookie.split("; ").find((e) => e.startsWith(this.name)) &&
        (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
  }
  customElements.get("newsletter-form") ||
    customElements.define(
      "newsletter-form",
      class extends HTMLElement {
        constructor() {
          (super(),
            (this.newsletter = this.querySelector("[data-newsletter-form]")),
            (this.sessionStorage = window.sessionStorage),
            (this.popup = this.newsletter.closest("[data-popup]")),
            (this.stopSubmit = !0),
            (this.isChallengePage = !1),
            (this.formID = null),
            this.checkForChallengePage(),
            (this.newsletterSubmit = (e) => this.newsletterSubmitEvent(e)));
        }
        connectedCallback() {
          (this.newsletter.addEventListener("submit", this.newsletterSubmit),
            this.isChallengePage || this.showMessage());
        }
        async newsletterSubmitEvent(e) {
          if (this.stopSubmit) {
            e.preventDefault();

            const email = this.newsletter.querySelector(
              'input[name="contact[email]"]',
            ).value;
            const languageCodeInput = this.newsletter.querySelector(
              'input[name="ietf-language-code"]',
            );
            const languageCode = languageCodeInput ? languageCodeInput.value : "";

            try {
              const formData = new URLSearchParams();
              formData.append("email", email);
              if (languageCode) formData.append("ietf-language-code", languageCode);
              const proxyResponse = await fetch(
                "/apps/schiesser-event-worker-app?topic=newsletter_signup",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                  },
                  body: formData,
                },
              );
              const data = await proxyResponse.json().catch(function () {
                return null;
              });
              if (data && data.state === "alreadySubscribed" && data.redirect) {
                window.location.href = data.redirect;
                return;
              }
              if (data && data.redirect) {
                this.sessionStorage.setItem(
                  "newsletter_redirect_url",
                  data.redirect,
                );
              }
            } catch (error) {
              console.error("newsletter pre-flight error:", error);
            }

            this.removeStorage();
            this.writeStorage();
            this.stopSubmit = !1;

            this.sessionStorage.setItem("newsletter_email", email);

            this.newsletter.submit();
          }
        }
        checkForChallengePage() {
          this.isChallengePage =
            window.location.pathname === theme.routes.root + "challenge";

          if (window.location.hash) {
            history.replaceState(
              null,
              "",
              window.location.pathname + window.location.search,
            );
          }
        }
        writeStorage() {
          void 0 !== this.sessionStorage &&
            this.sessionStorage.setItem(
              "newsletter_form_id",
              this.newsletter.id,
            );
        }
        readStorage() {
          void 0 !== this.sessionStorage &&
            (this.formID = this.sessionStorage.getItem("newsletter_form_id"));
        }
        removeStorage() {
          this.sessionStorage?.removeItem("newsletter_form_id");
        }
        showSuccessPopup() {
          const successMessage =
            this.newsletter
              .querySelector(".form-success")
              ?.textContent?.trim() || "Thank you for subscribing!";

          // Create popup-bar (popup small) element
          const wrapper = document.createElement("div");
          wrapper.setAttribute("data-popup", "");
          wrapper.setAttribute("data-popup-delay", "always");

          const popupEl = document.createElement("div");
          popupEl.className =
            "popup popup--bar popup--bar--no-image popup--visible popup--expanded";
          popupEl.id = "popup--newsletter-success";
          popupEl.setAttribute("data-popup-inner", "");
          popupEl.setAttribute("data-prevent-scroll-lock", "");
          popupEl.innerHTML = `
            <div class="popup__wrapper">
              <div class="popup__body" data-popup-body style="padding-top: 6px; padding-bottom: 6px;">
                <button class="popup__close" type="button" data-popup-close>
                  <span class="visually-hidden">Close</span>
                  <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 192 192"><path d="M150 42 42 150M150 150 42 42" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </button>

                <div class="popup__container" style="display: flex; align-items: center; justify-content: center;">
                  <div class="popup__form" style="margin: 4px 0; text-align: center;">
                    <div class="note form-success" style="display: inline-block; text-align: center;">
                      ${successMessage}
                    </div>
                  </div>
                </div>
              </div>

              <div class="popup__underlay" data-popup-underlay></div>
            </div>
          `;

          wrapper.appendChild(popupEl);
          document.body.appendChild(wrapper);
          document.body.classList.add("popup-bar-is-visible");

          // Close handlers
          let dismissed = false;
          const closePopup = (evt) => {
            if (dismissed) return;
            dismissed = true;
            if (evt) evt.preventDefault();
            clearTimeout(autoCloseTimer);
            document.removeEventListener("click", onDocumentClick);
            popupEl.classList.remove("popup--visible");
            document.body.classList.remove("popup-bar-is-visible");
            if (window.theme?.a11y) {
              window.theme.a11y.removeTrapFocus();
            }
            setTimeout(() => {
              document.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", { bubbles: !0 }),
              );
            }, 600);
            setTimeout(() => wrapper.remove(), 600);
            // Clean up URL params
            if (window.location.search) {
              history.replaceState(null, "", window.location.pathname);
            }
          };

          // Auto-dismiss after 5 seconds
          const autoCloseTimer = setTimeout(() => closePopup(), 5000);

          // Close when clicking anywhere on the page
          const onDocumentClick = () => closePopup();
          // Delay registering so the current event cycle doesn't immediately close it
          setTimeout(() => {
            document.addEventListener("click", onDocumentClick);
          }, 0);

          // Toggle expand/collapse
          const toggle = popupEl.querySelector("[data-popup-bar-toggle]");
          if (toggle) {
            toggle.addEventListener("click", (evt) => {
              evt.preventDefault();
              popupEl.classList.toggle("popup--expanded");
            });
          }

          popupEl
            .querySelector("[data-popup-close]")
            .addEventListener("click", closePopup);
          popupEl
            .querySelector("[data-popup-underlay]")
            .addEventListener("click", () => {
              if (toggle) toggle.dispatchEvent(new Event("click"));
            });
          popupEl.addEventListener("keyup", (e) => {
            if (e.code === "Escape") closePopup();
          });
        }
        async showMessage() {
          // Remove hash fragment from URL to prevent browser auto-scrolling to the form anchor
          if (window.location.hash) {
            history.replaceState(
              null,
              "",
              window.location.pathname + window.location.search,
            );
          }
          if ((this.readStorage(), this.newsletter.id === this.formID)) {
            const t = document.getElementById(this.formID),
              s =
                -1 !== window.location.search.indexOf("?customer_posted=true"),
              i = -1 !== window.location.search.indexOf("accepts_marketing");
            (s
              ? (t.classList.remove("has-error"),
                t.classList.add("has-success"),
                this.popup &&
                  ((this.cookie = new e(
                    this.popup.dataset.cookieName,
                    "user_has_closed",
                  )),
                  this.cookie.write()))
              : i &&
                (t.classList.remove("has-success"),
                t.classList.add("has-error")),
              s || i);

            if (s) {
              this.sessionStorage.removeItem("newsletter_email");
              const redirectUrl = this.sessionStorage.getItem(
                "newsletter_redirect_url",
              );
              if (redirectUrl) {
                this.sessionStorage.removeItem("newsletter_redirect_url");
                window.location.href = redirectUrl;
                return;
              }
            }

            // Fallback: show success popup if no pre-flight redirect was set
            if (s && !this.popup) {
              this.showSuccessPopup();
            }
          }
        }
        disconnectedCallback() {
          this.newsletter.removeEventListener("submit", this.newsletterSubmit);
        }
      },
    );
})();
